import { TweenMax, TimelineMax } from 'gsap';
import { Container, Sprite } from 'pixi.js';
import { createBitmapText, scaleToFit } from '../../../Utils/Utils';
import { getSpriteId } from '../../../Utils/CollectableUtils';
import { Collection } from '../../../Tiles/TileSet';

export class LevelGoalDisplay extends Container {
    public iconName: string;
    private numCounter: PIXI.extras.BitmapText;
    private goalIcon: Sprite;
    private spriteId: string;

    constructor(goalId: string, goalNum: number, width: number, height: number) {
        super();

        this.spriteId = goalId;
        const goalIcon = new Sprite(
            PIXI.utils.TextureCache['commonui/top-hud-goal-icon-' + goalId]
        );
        goalIcon.scale.set(scaleToFit(goalIcon.width, goalIcon.height, width * 0.4, height * 0.9));
        goalIcon.x = width * 0.2;
        goalIcon.y = height * 0.47;
        // text
        const goalTxt = createBitmapText(
            goalNum.toString(),
            new PIXI.Rectangle(0, 0, width * 0.4, height * 0.5),
            'riffic'
        );
        goalTxt.anchor = 0.5;
        goalTxt.x = width / 2;
        goalTxt.y = height * 0.59;
        //@ts-ignore
        this.addChild(goalIcon, goalTxt);

        this.numCounter = goalTxt;
        this.goalIcon = goalIcon;
        this.goalIcon.anchor.set(0.5);
    }

    public getGoalIcon() {
        return this.goalIcon;
    }

    public updateGoalIcon(iconId: string, collection: Collection) {
        this.spriteId = iconId;
        // placeholder for all object until we have more goal options and set up configs for it
        this.goalIcon.texture =
            PIXI.utils.TextureCache[
                getSpriteId('commonui/top-hud-goal-icon-' + iconId, collection)
            ];
    }

    public updateLevelGoal(num: number) {
        if (parseInt(this.numCounter.text, 10) !== num) {
            let delayNum = 0;
            if (this.spriteId === 'toys') {
                delayNum = 1.15;
            }
            new TimelineMax()
                .to(this.goalIcon.scale, 0.2, {
                    delay: delayNum,
                    x: 1.2,
                    y: 1.2,
                })
                .to(this.goalIcon.scale, 0.2, {
                    x: 1,
                    y: 1,
                });
        }
        this.numCounter.text = num.toString(10);
    }

    public cleanUp() {
        TweenMax.killTweensOf(this.goalIcon);
        this.goalIcon.destroy();
        this.numCounter.destroy();
        this.destroy();
    }
}
